import { useEffect } from 'react';
import { useProperty, useSiteContext, useTranslation } from '@eti/providers';
import { useAuth } from '@eti/authentication';
import { closeWebMessagesChat, initWebMessages } from './utils';

export const useWebMessagesChat = (isWebMessagesEnabled: boolean, userName?: string) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { user } = useAuth();
  const { language, siteName } = useSiteContext();
  const siteLanguageCode = language.code;

  useEffect(() => {
    if (isWebMessagesEnabled) {
      const webMessagesScript = document.getElementById('webMessagesScript');
      const deploymentId: string = p('Chat.WebMessages.DeploymentKey');

      if (user && !webMessagesScript) {
        initWebMessages(
          siteName,
          siteLanguageCode,
          userName,
          user?.email,
          user?.sessionOrderNumber,
          deploymentId,
        );
      }
      if (webMessagesScript && !user) {
        closeWebMessagesChat();
      }
    }
  }, [
    siteName,
    user?.email,
    user?.sessionOrderNumber,
    siteLanguageCode,
    p,
    t,
    user,
    userName,
    isWebMessagesEnabled,
  ]);

  return null;
};
